import React, { useContext, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Collapse from '@material-ui/core/Collapse';

import { AnswerContext } from '../../index';
import { Container } from './styles';

function StepFive() {
  const { state, dispatch, WizardContext } = useContext(AnswerContext);
  const { dispatch: wizardDispatch } = useContext(WizardContext);

  function setRequired(required) {
    dispatch({ type: 'SET_REQUIRED', required: required });
    wizardDispatch({ type: 'NEXT_STEP' });
  }

  function handleChange(event) {
    let value;

    if (event.target.type === 'number') {
      value = Number(event.target.value);
      if (value < 1) return;
    } else {
      value = event.target.checked;
    }

    dispatch({
      type: 'CHANGE_FIELD',
      field: event.target.name,
      value: value,
    });
  }

  useEffect(() => {
    wizardDispatch({
      type: 'SET_IS_COMPLETE',
      isComplete: state.required === null ? false : true,
    });
  }, [state]);

  return (
    <Container>
      <TextField
        autoFocus={true}
        style={{ width: '80px' }}
        id='outlined-number'
        label='Mínimo'
        type='number'
        name='min'
        value={state.min}
        placeholder='1'
        required
        onChange={handleChange}
        InputLabelProps={{
          shrink: true,
        }}
        variant='outlined'
      />
      <TextField
        style={{ marginLeft: '20px', width: '80px' }}
        id='outlined-number'
        label='Máximo'
        type='number'
        name='max'
        required
        value={state.max}
        onChange={handleChange}
        placeholder='1'
        InputLabelProps={{
          shrink: true,
        }}
        variant='outlined'
      />
      <Collapse in={state.max > 1}>
        <FormControlLabel
          style={{ marginTop: '20px' }}
          control={
            <Switch
              name='multiple'
              color='primary'
              checked={state.multiple}
              onChange={handleChange}
            />
          }
          label='O cliente pode escolher a mesma opção varias vezes'
        />
      </Collapse>
    </Container>
  );
}

export default StepFive;
